/** 裸金属系统交付 / 引导 / 纳管账号字段（逻辑 field key） */
export const BARE_METAL_PROVISIONING_FIELD_KEYS = {
  provisioningMode: 'provisioning.mode',
  bootMode: 'boot.mode',
  systemArchitecture: 'systemVolume.architecture',
  systemOs: 'systemVolume.os',
  systemVersion: 'systemVolume.version',
  accountPasswd: 'account.passwd',
  accountPrivatedKey: 'account.privatedKey',
} as const;

export const BARE_METAL_PROVISIONING_FIELD_KEY_LIST = [
  BARE_METAL_PROVISIONING_FIELD_KEYS.provisioningMode,
  BARE_METAL_PROVISIONING_FIELD_KEYS.bootMode,
  BARE_METAL_PROVISIONING_FIELD_KEYS.systemArchitecture,
  BARE_METAL_PROVISIONING_FIELD_KEYS.systemOs,
  BARE_METAL_PROVISIONING_FIELD_KEYS.systemVersion,
  BARE_METAL_PROVISIONING_FIELD_KEYS.accountPasswd,
  BARE_METAL_PROVISIONING_FIELD_KEYS.accountPrivatedKey,
] as const;
